import { ValidatorFn } from '@angular/forms';
import { isEmptyString, isNil, isNumber } from '@web/utils';
import { ValidationError } from '../enums/validation-error';

export class NipValidator {
  public static nip = ((): ValidatorFn => {
    return (control) => {
      const { value } = control;

      if (isNil(value)) {
        return null;
      }

      if (isEmptyString(value)) {
        return null;
      }

      const nip: string = isNumber(value)
        ? value.toString()
        : value.replace(/-/g, '');

      if (nip.length !== 10) {
        return {
          [ValidationError.NIP]: true,
        };
      }

      if (new Set(nip.split('')).size === 1) {
        return {
          [ValidationError.NIP]: true,
        };
      }

      const nipArray: number[] = nip
        .split('')
        .map((segment) => parseInt(segment));

      const checkSum =
        (6 * nipArray[0] +
          5 * nipArray[1] +
          7 * nipArray[2] +
          2 * nipArray[3] +
          3 * nipArray[4] +
          4 * nipArray[5] +
          5 * nipArray[6] +
          6 * nipArray[7] +
          7 * nipArray[8]) %
        11;

      if (nipArray[9] === checkSum) {
        return null;
      }

      return {
        [ValidationError.NIP]: true,
      };
    };
  })();
}
